import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  InputBase,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

export default function AssignedSearch({ value, onChange, onAdd, fullWidth, addColor = "#7cb342", addDisabled = false }) {
  const [text, setText] = useState(value || "");

  useEffect(() => {
    const t = setTimeout(() => onChange(text), 300);
    return () => clearTimeout(t);
  }, [text, onChange]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: fullWidth ? '100%' : 900,
        padding: !onAdd ? "0.2rem" : "0",
        borderRadius: "4px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        overflow: "hidden",
      }}
    >
      {/* Search icon */}
      <Box sx={{ px: 1.5, color: "text.secondary" }}>
        <SearchIcon />
      </Box>

      {/* Divider */}
      <Box
        sx={{
          width: "1px",
          height: 24,
          backgroundColor: "#e0e0e0",
        }}
      />

      {/* Input */}
      <InputBase
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Որոնել"
        sx={{
          flex: 1,
          px: 2,
          fontSize: 16,
        }}
      />

      {/* Clear */}
      {text && (
        <IconButton onClick={() => setText("")}>
          <ClearIcon />
        </IconButton>
      )}

      {/* Add button */}
      {onAdd && (
        <Box
          sx={{
            backgroundColor: addColor,
            px: 2,
            height: "100%",
            display: "flex",
            alignItems: "center",
            opacity: addDisabled ? 0.5 : 1,
            cursor: addDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          <IconButton onClick={onAdd} sx={{ color: "#fff" }} aria-disabled={addDisabled}>
            <AddIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
}
